import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { registerDataValidationErrorMatcher } from 'errors/dataValidationError';
import useKeyDownListener from 'hooks/useKeyDownListener';
import CheckSvg from 'images/v5/icons/check.svg';
import Button from 'layout/atoms/Button/Button';
import Input from 'layout/atoms/Input/Input';
import InputLabel from 'layout/atoms/InputLabel';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { updateSpecificationProjectionName } from 'store/specificationProjectionsSlice';
function ProjectionNameEditor({ onClose }) {
    var _a;
    const { t } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const projectionData = (_a = useSelector(selectModalByName('projectionNameEditor'))) === null || _a === void 0 ? void 0 : _a.data;
    const [formDara, setFormData] = useState({
        name: '',
    });
    const [error] = useState('');
    const statusAdd = useSelector((state) => state.specificationsFolders.status.add);
    const statusUpdate = useSelector((state) => state.specificationsFolders.status.update);
    useEffect(() => {
        setFormData({
            name: projectionData.name,
        });
    }, [projectionData === null || projectionData === void 0 ? void 0 : projectionData.name]);
    const handleFormChange = ({ target: { name, value }, }) => {
        setFormData((folder) => (Object.assign(Object.assign({}, folder), { [name]: value })));
    };
    const handleNameEdit = () => {
        dispatch(updateSpecificationProjectionName(Object.assign(Object.assign({}, formDara), { projectionId: projectionData.id }))).then(() => dispatch(closeModal({ name: 'projectionNameEditor' })));
    };
    const handleSave = () => {
        handleNameEdit();
    };
    registerDataValidationErrorMatcher();
    useKeyDownListener([
        { code: 'Enter', callback: handleSave },
        { code: 'Escape', callback: onClose },
    ]);
    return (React.createElement(Modal, { name: "projectionNameEditor", size: "s", header: React.createElement(Label, { weight: "strong" }, t('change_projection_name')), footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { theme: "ghost", onClick: () => dispatch(closeModal({ name: 'projectionNameEditor' })) }, t('cancel')),
            React.createElement(Button, { color: "primary", leftIcon: React.createElement(CheckSvg, null), onClick: handleSave, loading: statusAdd === 'loading' || statusUpdate === 'loading', submit: true }, t('common:save'))) },
        React.createElement(InputLabel, { text: t('folder_name') }),
        React.createElement(Input, { value: formDara === null || formDara === void 0 ? void 0 : formDara.name, onChange: handleFormChange, name: "name", autoFocus: true }),
        error && React.createElement("h5", { className: "errorText" }, error)));
}
export default memo(ProjectionNameEditor);
